import React, { useState, useEffect, useRef } from 'react';
import { obtenerArchivosDatos, obtenerArchivosDian, subirArchivosDatos, subirArchivosDian } from '../services/gestionArchivosService';
import LoaderDialog from './loading';

const GestorArchivos = ({ setGestionarArchivos }) => {
    const [archivos, setArchivos] = useState([]);
    const [archivosDian, setArchivosDian] = useState([]);
    const [archivoSeleccionado, setArchivoSeleccionado] = useState(null);
    const [archivoSeleccionadoDian, setArchivoSeleccionadoDian] = useState(null);
    const [mensajeDatos, setMensajeDatos] = useState('');
    const [mensajeDian, setMensajeDian] = useState('');
    const inputFileDatosRef = useRef(null);
    const inputFileDianRef = useRef(null);
    const [loading, setLoading] = useState(false);

    // Obtener lista de archivos desde el servidor
    const fetchArchivos = async () => {
        setLoading(true);
        try {
            const data = await obtenerArchivosDatos();
            setArchivos(data.archivos || []); // Asegura que 'archivos' siempre sea un array
        } catch (error) {
            console.error("Error al cargar archivos de datos:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchArchivosDian = async () => {
        setLoading(true);
        try {
            const data = await obtenerArchivosDian();
            setArchivosDian(data.archivos || []);
        } catch (error) {
            console.error("Error al cargar archivos DIAN:", error);
        } finally {
            setLoading(false);
        }
    };

    // Manejar la selección del archivo
    const handleArchivoSeleccionado = (event) => {
        setArchivoSeleccionado(event.target.files[0]);
    };

    const handleArchivoSeleccionadoDian = (event) => {
        setArchivoSeleccionadoDian(event.target.files[0]);
    };

    const salirDeMacros = () => {
        setGestionarArchivos(false);
    };

    // Subir archivo y reemplazar el más antiguo
    const handleSubirArchivo = async (e) => {
        setLoading(true);
        e.preventDefault();
        if (!archivoSeleccionado) {
            setMensajeDatos('Por favor, selecciona un archivo antes de subir.');
            setLoading(false);
            return;
        }
        try {
            const data = await subirArchivosDatos(archivoSeleccionado);
            setMensajeDatos(data.mensaje);
            setArchivoSeleccionado(null);
            if (inputFileDatosRef.current) {
                inputFileDatosRef.current.value = ""; // Limpiar el input file
            }
            fetchArchivos();
        } catch (error) {
            console.error('Error al subir el archivo:', error);
            setMensajeDatos('Error al subir el archivo.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubirArchivoDian = async (e) => {
        setLoading(true);
        e.preventDefault();
        if (!archivoSeleccionadoDian) {
            setMensajeDian('Por favor, selecciona un archivo antes de subir.');
            setLoading(false);
            return;
        }
        try {
            const data = await subirArchivosDian(archivoSeleccionadoDian);
            setMensajeDian(data.mensaje);
            setArchivoSeleccionadoDian(null);
            if (inputFileDianRef.current) {
                inputFileDianRef.current.value = ""; // Limpiar el input file
            }
            fetchArchivosDian();
        } catch (error) {
            console.error('Error al subir el archivo DIAN:', error);
            setMensajeDian('Error al subir el archivo.');
        } finally {
            setLoading(false);
        }
    };

    // Obtener archivos al cargar el componente
    useEffect(() => {
        fetchArchivos();
        fetchArchivosDian();
    }, []);

    return (
        <>
            <LoaderDialog visible={loading} />
            <div className='row'>
                <div className='col-6'>
                    <div className="card p-1 mx-auto shadow d-flex flex-column justify-content-center align-items-center">
                        <h3 className='p-2'>Archivos de datos disponibles</h3>
                        <div className='container shadow'>
                            <div className="row border fw-bold">
                                <div className='col-4 border'>Archivo</div>
                                <div className='col-8 border'>Última modificación</div>
                            </div>
                            {archivos.map((archivo, index) => (
                                <div className="row border" key={index}>
                                    <div className="col-4 border">
                                        <img src="./icon_doc.png" alt="Documento" width="40" height="50" />
                                        <div className='d-flex justify-content-center'>{archivo.nombre}</div>
                                    </div>
                                    <div className="col-8 border d-flex justify-content-center align-items-center">
                                        {new Date(archivo.fechaModificacion || Date.now()).toLocaleString()}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='container'>
                            <h5>Agregar archivo de datos actual</h5>
                            <input className="form-control" type="file" ref={inputFileDatosRef} onChange={handleArchivoSeleccionado} />
                            <button className='btn btn-consulta btn-sm mt-2' onClick={handleSubirArchivo}>Subir archivo</button>
                            {mensajeDatos && <div className='text-danger mt-2'>{mensajeDatos}</div>}
                        </div>
                    </div>
                </div>
                <div className='col-6'>
                    <div className="card p-1 mx-auto shadow d-flex flex-column justify-content-center align-items-center">
                        <h3 className='p-2'>Archivos de datos DIAN</h3>
                        <div className='container shadow'>
                            <div className="row border fw-bold">
                                <div className='col-4 border'>Archivo</div>
                                <div className='col-8 border'>Última modificación</div>
                            </div>
                            {archivosDian.map((archivo, index) => (
                                <div className="row border" key={index}>
                                    <div className="col-4 border">
                                        <img src="./icon_doc.png" alt="Documento DIAN" width="40" height="50" />
                                        <div className='d-flex justify-content-center'>{archivo.nombre}</div>
                                    </div>
                                    <div className="col-8 border d-flex justify-content-center align-items-center">
                                        {new Date(archivo.fechaModificacion || Date.now()).toLocaleString()}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='container'>
                            <h5>Agregar archivo DIAN</h5>
                            <input className="form-control" type="file" ref={inputFileDianRef} onChange={handleArchivoSeleccionadoDian} />
                            <button className='btn btn-consulta btn-sm mt-2' onClick={handleSubirArchivoDian}>Subir archivo</button>
                            {mensajeDian && <div className='text-danger mt-2'>{mensajeDian}</div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12 d-flex justify-content-center">
                    <button className="btn btn-consulta btn-sm" onClick={salirDeMacros}>Regresar a gestión</button>
                </div>
            </div>
        </>
    );
};

export default GestorArchivos;

